<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 call-container theme-color-wrapper mt-0 p-0">
        <div id="videoContainer">
          <audio id="mt-audio" class="rounded centered" autoplay playsinline />
          <div class="row video-container-row">
            <!-- Prisoner Media -->
            <div v-if="!loadingVisit" class="col-12">
              <div id="remote-media">
                <div class="prisoner-pause-btn">
                  <i v-if="!visitorMuted" class="fas fa-microphone" />
                  <i v-if="visitorMuted" class="fas fa-microphone-slash" />
                </div>
                <video id="remote-video-feed" class="rounded centered" style="position: absolute" width="100%" height="100%"
                       autoplay playsinline :muted="muteRemoteAudio" :class="{ 'soft-pause': muteRemoteVideo }"
                />
                <!-- Visitor Media -->
                <div class="visitor-media">
                  <div id="local-media">
                    <div class="prisoner-pause-btn hover-pointer cursor-pointer">
                      <i v-if="!muted" class="fas fa-microphone" @click="setMuted(true)" />
                      <i v-if="muted" class="fas fa-microphone-slash" @click="setMuted(false)" />
                    </div>
                    <video id="local-video-feed" class="rounded centered" width="100%" height="100%" autoplay playsinline muted="muted" />
                  </div>
                </div>

                <p v-if="waitingForVisitor && callState === 'ACTIVE'" class="warning-text">
                  {{ getWaitingForText() }}
                </p>
                <p v-if="visitorNoVideo && callState === 'ACTIVE'" class="warning-text">
                  {{ getVisitorNoVideoText() }}
                </p>

                <div v-if="callState === 'PAUSED_INVALID_FACES' || callState === 'PAUSED_ADULT_CONTENT'" class="warning-text__behaviour-bg" />
                <div v-if="callState === 'PAUSED_INVALID_FACES'" class="warning-text warning-text__behaviour">

                  <span class="warning-text__behaviour__icon"><i class="fas fa-exclamation-circle" /></span>
                  <h2 class="warning-text__behaviour__title">Someone unexpected on the call</h2>
                  <p>Only approved people should be on the call</p>
                  <p>
                    You need to make sure your whole face is on camera, and there's a plain background behind you
                  </p>
                </div>

                <div v-if="callState === 'PAUSED_ADULT_CONTENT'" class="warning-text warning-text__behaviour">
                  <span class="warning-text__behaviour__icon"><i class="fas fa-exclamation-circle" /></span>
                  <h2 class="warning-text__behaviour__title">Possible inappropriate behaviour</h2>
                  <p>All callers must be fully dressed and follow rules for social calls</p>
                  <p>Video will be stopped until this is fixed</p>

                  <h5 style="margin-top: 15px">Did we get it wrong?</h5>
                  <p>Sometimes this happens when there's a baby on camera or lots of skin showing</p>

                </div>
                <!--                <p class="warning-text" v-if="callState === 'PAUSED_ADULT_CONTENT'">-->
                <!--                  {{getPausedAdultContentText()}}-->
                <!--                </p>-->
                <p v-else-if="callState === 'PAUSED_MT'" class="warning-text">
                  {{ getMtPausedText() }}
                </p>
                <p v-else-if="callState === 'PAUSED_APP_IN_BACKGROUND'" class="warning-text">
                  {{ getPausedAppInBackgroundText() }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="col-12 p-1 m-0 theme-color-wrapper call-action-bar">
        <div class="row align-items-center call-action-bar__row">
          <div class="text-center d-flex col-4">
            <clock />
            <h4 v-if="!loadingVisit && !loadingPrison && visit.should_record" class="mb-0 ml-2 text-white">Recording <span class="fas fa-circle text-danger" /></h4>
          </div>

          <div class="col-5 d-flex align-items-center justify-content-center">
            <b-btn class="round" variant="danger" :disabled="callState === 'PAUSED_MT'" @click="endCall()">
              <span class="fas fa-phone-slash" />
            </b-btn>
          </div>

          <div v-if="mounted" class="col-3 d-flex justify-content-between align-items-center">
            <visit-countdown
              :visit="visit"
              :prison="prison"
              :leave-call="endCallFeedback"
            />
            <h4 v-if="!loadingVisit" class="mb-0 pb-0 text-white">Call Ends: {{ getVisitEndTime() }}</h4>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style type="text/css" scoped lang="scss">
body {
  background: #1C1B22;
}

.visitor-media {
  width: 200px;
  position: absolute;
  bottom: 15px;
  right: 15px;

  @include mobile() {
    width: 150px;
  }
}

.call-container {
  height: 87.5vh;
  max-height: 87.5vh;
  margin-top: 1em;
  overflow: hidden;
}

#local-media {
  position: relative;
}

.prisoner-pause-btn {
  color: white;
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 1;
}

#videoContainer {
  height: 100%;
}

.video-container-row {
  height: 100%;
}

#remote-media {
  position: relative;
  background-color: #1C1B22;
  height: 100%;
}

.warning-text {
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
  font-weight: bold;
}

.warning-text__behaviour-bg {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.2);
}

.warning-text__behaviour{
  width: 80%;
}

.warning-text__behaviour__title{
  margin-bottom: 30px;
}

.warning-text__behaviour p{
  font-weight: 100;
  max-width: 70%;
  margin: auto;
  margin-bottom: 10px;
}

.warning-text__behaviour__icon{
  color: #E63365;
  font-size: 40pt;
  position: relative;
}

.warning-text__behaviour__icon ::after{
  content: "";
  position: absolute;
  top: 18px;
  left: 10px;
  background-color: white;
  width: 25px;
  height: 35px;
  z-index: -1;
}

.soft-pause {
  filter: brightness(0);
}

.call-action-bar {
  max-width: 100%;
  flex: 0 100%;
  background-color: #1C1B22;
  &__row {
    @include mobile-portrait() {
      flex-direction: column;
    }
  }
}
</style>

<script>
import Vvrtc from 'vvrtc-js';
import {mapState} from 'vuex';
import axios from '@axios';
import {
  CALL_EVENT_ACTION_SUB_TYPES,
  CALL_EVENT_EVENT_SUB_TYPES,
  CALL_EVENT_TYPES,
} from '@/util/callActionsAndEvents';
import moment from 'moment';
import { getDateTimeOfSlot } from '@/util/helpers';
import io from 'socket.io-client';
import { logger } from '@/util/logger';
import Clock from '../clock/Clock.vue';
import { getWsEndpoint } from '../../../endpoints';
import VisitCountdown from '../clock/VisitCountdown.vue';

let socket;

const CALL_STATES = {
  ACTIVE: 'ACTIVE',
  PAUSED_INVALID_FACES: 'PAUSED_INVALID_FACES',
  PAUSED_MT: 'PAUSED_MT',
  PAUSED_ADULT_CONTENT: 'PAUSED_ADULT_CONTENT',
  PAUSED_APP_IN_BACKGROUND: 'PAUSED_APP_IN_BACKGROUND',
};

Vvrtc.logAll = false;

export default {
  name: 'VisitCallVvrtc',
  components: {
    VisitCountdown,
    Clock,
  },
  data() {
    return {
      muteRemoteAudio: false,
      muteRemoteVideo: false,
      muted: false, // own mute
      visitorMuted: false, // microphone self mute
      leavingNaturally: false,
      snapshotIntervalId: null,
      activeRoom: null,
      identity: null,
      visit: {},
      visitId: this.$route.params.id,
      prisonerNumber: this.$route.params.prisonerNumber,
      callState: CALL_STATES.ACTIVE, // ACTIVE | PAUSED_INVALID_FACES | PAUSED_MT
      callStateLastUpdate: null,
      waitingForVisitor: true,
      visitorNoVideo: false,
      loading: true,
      loadingVisit: true,
      notification: null,
      // Face Detection local settings
      in_call_security_settings: null,
      faceIntervalDetectionId: null,
      faceDetactionTimeoutId: null,
      remoteVideoElement: null,
      faceDetectorModelLoaded: null,
      totalFacesCounted: 0,
      countsHappened: 0,
      detectorOptions: {},
      lastDetectionEvent: null,
      // Face Util
      verificationRetries: 0,
      // Call State Polling
      latestCallStateIntervalId: null,
      // Audio settings
      audioInputDeviceId: null,
      audioOutputDeviceId: null,
      // Datatracks
      mtDataTrackIds: [],
      visitorDataTrackIds: [],
      wsConnected: false,
      visitorAppInForeground: true,
      // Screenshots
      screenShotsTaken: 0,
      // Volume
      volume: 50,
      // Rotation
      rotationDegrees: 0,
      // Adult content
      adultContentWarningShowing: false,
      screenShotLimit: 2,
      visitorStream: null,
      localStream: null,
      prison: null,
      loadingPrison: true,
      mounted: false,
      id: null,
    };
  },
  computed: {
    ...mapState({
      fullscreen: state => state.fullscreen,
    }),
  },
  async mounted() {
    this.$store.commit('SET_IS_FULLSCREEN', true);
    this.visitId = this.$route.params.id;
    // Fetch visit info
    this.fetchVisit();
    // Wait for these two before rendering
    await this.joinRoom();
    await this.handleWS();

    // Fetch latest call state
    this.fetchLatestCallAction();
    this.pollLatestCallAction();
    this.fetchTimesScreenShotted();
    // this.checkForScreenshots();

    // Setting a flag as it's important not to let anything move away from this page before it is mounted. I've added
    // v-if="mounted" on the countdown timer to make sure it only kicks in once the component is actually mounted
    // otherwise the beforeDestroy and Destroyed methods are called, first, then the mounted conde continues afterwards.
    // Any component that may redirect away from this page needs to ensure the module is mounted first.
    this.mounted = true;
  },
  async beforeDestroy() {
    await this.destroyStream();
    this.$store.commit('SET_IS_FULLSCREEN', false);
  },
  methods: {
    async destroyStream() {
      if (this.localStream != null) {
        this.localStream.getTracks().forEach(track => {
          track.stop();
        });
      }

      if (socket) {
        socket.disconnect();
      }

      await this.leaveRoomIfJoined();
    },
    // ########################### Visit Methods #############################
    fetchPrisonInfo(prisonId) {
      axios({
        url: `/api/v1/prisons/single-prison/${prisonId}`,
        method: 'GET',
      }).then(res => {
        this.prison = res.data;
        this.screenShotLimit = this.prison.screen_shot_limit;
        this.loadingPrison = false;
      }).catch(err => {
        logger.error('Unable to get prison ', err, null, 'VisitCall:fetchPrisonInfo');
        this.$toast.warning('There was a problem getting a your establishment details, please refresh and try again.', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      });
    },
    fetchVisit() {
      axios({
        url: `/api/v1/visits/single-visit/${this.visitId}`,
        method: 'GET',
      }).then(res => {
        this.visit = res.data;
        this.loadingVisit = false;
        this.fetchPrisonInfo(this.visit.prison.prison_id);
      }).catch(err => {
        logger.error('There was a problem getting your video call details, please refresh and try again.', err, null, 'VisitCall:fetchVisit');
        this.$toast.warning('There was a problem getting your video call details, please refresh and try again.', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
        // Redirect to dashboard
        this.goToDashboard();
      });
    },
    isCallReady(call) {
      return call.call_state.call_security_joined && call.call_state.prisoner_in_call;
    },
    getVisitEndTime() {
      if (this.visit && this.visit.booked_slot) {
        const endDateTime = getDateTimeOfSlot(this.visit.booked_slot).endDate;
        return moment(endDateTime).format('HH:mm');
      }
      return '-';
    },
    // #######################################################################
    // #################### Call Status Sync Methods #########################
    // These methods are used as a fallback in case the datatracks fail to receive a message
    pollLatestCallAction() {
      this.latestCallStateIntervalId = setInterval(() => {
        logger.message('>> Polling');
        this.fetchLatestCallAction();
      }, 5000);
    },
    fetchLatestCallAction() {
      axios({
        url: `/api/v1/call-events/for-visit/${this.visitId}/latest-action`,
        method: 'GET',
      }).then(res => {
        const latestCallAction = res.data;

        if (latestCallAction) {
          let isAfter = true;
          // Check we have a last call state updated
          if (this.callStateLastUpdate) {
            const fetchedCreatedAt = moment(latestCallAction.created_at).toDate();
            const localCreatedAt = moment(this.callStateLastUpdate).toDate();
            isAfter = moment(fetchedCreatedAt).isAfter(localCreatedAt, 'second');
          }

          // Check if latest call action is newer than callStateLastUpdate
          if (isAfter) {
            this.handleCallEvent(latestCallAction);
          }
        }
      }).catch(err => {
        logger.error('Cannot get latest call action', err, { visitId: this.visitId }, 'VisitCall:fetchLatestCallAction');
      });
    },
    fetchTimesScreenShotted() {
      axios({
        url: `/api/v1/call-events/for-visit/${this.visitId}/times-screenshotted`,
        method: 'GET',
      }).then(res => {
        this.screenShotsTaken = res.data.times_screen_shotted || 0;
      }).catch(err => {
        logger.error('Cannot get times screenShotted', err, { visitId: this.visitId }, 'VisitCall:fetchTimesScreenShotted');
      });
    },
    // #######################################################################
    // ##################### Joining/Leaving Methods #########################
    setPrisonerJoinedCalled() {
      const prisonerJoinedCallDto = {
        visit_id: this.visitId,
        type: 'Event',
        sub_type: 'Prisoner_Joined',
      };
      this.createPrisonerEvent(prisonerJoinedCallDto);
    },
    setPrisonerLeftCall() {
      const prisonerLeftCallDto = {
        visit_id: this.visitId,
        type: 'Event',
        sub_type: 'Prisoner_Left',
      };
      this.createPrisonerEvent(prisonerLeftCallDto);
    },
    createPrisonerEvent(dto) {
      axios({
        url: '/api/v1/call-events/create/general',
        method: 'POST',
        data: dto,
      }).catch(err => {
        logger.error('Cannot create call event', err, {
          dto,
          visitId: this.visitId,
        }, 'VisitCall:createPrisonerEvent');
      });
    },
    async joinRoom() {
      // Get the room name (visitId) and prisoner number
      const selectedCameraId = localStorage.getItem('cameraDeviceId');
      const selectedAudioInputId = localStorage.getItem('audioInputDeviceId');
      this.audioOutputDeviceId = localStorage.getItem('audioOutputDeviceId');

      try {
        // Get room details from the server
        const response = await axios({
          url: `/api/v1/call/${this.visitId}/prisoner-in-cell`,
          method: 'GET',
        });

        // Set the connection Options
        const connectionOptions = {
          identity: response.data.identity,
          token: response.data.token,
          media: {
            audio: true,
            video: true,
          },
          servers: response.data.servers,
        };

        // Select the Audio Input if set.
        if (selectedAudioInputId) {
          connectionOptions.media.audio = {
            deviceId: selectedAudioInputId,
          };
        }

        // Select the Camera if set
        if (selectedCameraId) {
          connectionOptions.media.video = {
            deviceId: selectedCameraId,
          };
        }

        // Select the Audio output if set.
        if (this.audioOutputDeviceId) {
          connectionOptions.outputDevice = this.audioOutputDeviceId;
        }

        // Connect to the server
        await Vvrtc.connect(connectionOptions);

        // handle any messages coming from the server.
        this.handleMessages();

        // Join the Room
        Vvrtc.joinRoom(this.visitId, response.data.roomPin);
      } catch (error) {
        logger.error(
          'Unable to join room', error, { visitId: this.visitId }, 'VisitCall:joinRoom:2',
        );

        this.$swal({
          title: 'Unable to join call',
          text: 'Please check your headset is connected',
          icon: 'warning',
          button: 'Ok',
        }).then(() => {
          // Redirect to visit details
          this.goToWaitingRoom();
        });
      }
    },
    goToWaitingRoom() {
      // eslint-disable-next-line no-underscore-dangle
      this.$router.push({ name: 'waiting-room', params: { id: this.visit._id } });
    },
    async leaveRoomIfJoined() {
      this.leavingNaturally = true;

      clearInterval(this.snapshotIntervalId);
      clearInterval(this.faceIntervalDetectionId);
      clearInterval(this.latestCallStateIntervalId);

      await Vvrtc.destroy();
    },
    endCallFeedback() {
      this.endCall();
    },
    async endCall() {
      this.createGeneralEvent({
        visit_id: this.visitId,
        type: CALL_EVENT_TYPES.EVENT,
        sub_type: CALL_EVENT_EVENT_SUB_TYPES.PRISONER_LEFT,
      });

      // Leave the room
      await this.leaveRoomIfJoined();

      this.goToDashboard();
    },
    async callTerminated() {
      // Leave the room
      await this.leaveRoomIfJoined();
      // Redirect back to the dashboard
      this.goToDashboard();
    },
    callPausedInvalidFace() {
      if (this.callState !== CALL_STATES.PAUSED_INVALID_FACES) {
        this.$toast.warning('Call paused due to invalid faces detected in stream', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
        this.muteVisitorAudioAndHideVideo();
        // Set the call state to show overlay
        this.callState = CALL_STATES.PAUSED_INVALID_FACES;
        this.callStateLastUpdate = new Date();
      }
    },
    callPausedAdultContent() {
      if (this.callState !== CALL_STATES.PAUSED_ADULT_CONTENT) {
        this.$toast.warning('Call paused due to adult content detected in stream', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
        this.muteVisitorAudioAndHideVideo();
        // Set the call state to show overlay
        this.callState = CALL_STATES.PAUSED_ADULT_CONTENT;
        this.callStateLastUpdate = new Date();
      }
    },
    callPausedMT() {
      if (this.callState !== CALL_STATES.PAUSED_MT) {
        // Set the call state
        this.callState = CALL_STATES.PAUSED_MT;
        this.callStateLastUpdate = new Date();
        // Mute and remove the visitors audio and video
        this.muteVisitorAudioAndHideVideo();
      }
    },
    // ###########################################
    // ######## Snapshot Methods #################
    snapshotCall() {
      const localVideoElement = document.getElementById('local-video-feed');

      const wsSnapshots = {
        visit_id: this.visitId,
        image: null,
        user_id: this.prisonerNumber,
        user_type: 'prisoner',
      };

      if (localVideoElement) {
        wsSnapshots.image = this.getImageDataUrlFromVideo(localVideoElement);
      }

      socket.emit('callPreviewImageData', wsSnapshots);

      // Call every 1500 seconds
      this.snapshotIntervalId = setTimeout(() => {
        this.snapshotCall();
      }, 1500);
    },
    getImageDataUrlFromVideo(videoElement) {
      return this.getImageDataUrl(videoElement, 0.1);
    },
    getImageDataUrlFromVideoForFacialVerification(videoElement) {
      return this.getImageDataUrl(videoElement, 0.4);
    },
    getImageDataUrl(videoElement, quality) {
      if (!videoElement) {
        return null;
      }
      const canvas = document.createElement('canvas');
      canvas.width = videoElement.videoWidth;
      canvas.height = videoElement.videoHeight;
      canvas.getContext('2d').drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/jpeg', quality);
    },
    goToDashboard() {
      this.$router.push({ name: 'dashboard' });
    },
    getLocalPreviewContainer() {
      return document.getElementById('local-media');
    },
    getRemotePreviewContainer() {
      return document.getElementById('remote-media');
    },

    /**
     * Handle Messages from Vvrtc
     */
    handleMessages() {
      // If there is an error connecting to the room
      Vvrtc.on('room:local:error', data => {
        const { error } = data;
        const { error_code } = data;

        let message = 'Unable to connect to room';

        // eslint-disable-next-line camelcase
        if (error_code === 426) {
          message = 'The room for your call does not exist';
        }

        this.connectionError(error, message);
      });

      // When the local Stream is attached, show the video
      Vvrtc.on(Vvrtc.EventsType.localStream, stream => {
        // Set the prisoner as 'joined'
        this.localStream = stream;

        this.setPrisonerJoinedCalled();
        const previewContainer = document.getElementById('local-video-feed');
        Vvrtc.attachMediaStream(previewContainer, stream, true);
      });

      // Error publishing own feed
      Vvrtc.on(Vvrtc.EventsType.localPublishError, data => {
        this.connectionError(data.error, 'There was an error publish your video Feed. Please try again.');
      });

      // If the sessions or room is destroyed
      Vvrtc.on(Vvrtc.EventsType.sessionDestroyed, this.sessionFinished);
      Vvrtc.on(Vvrtc.EventsType.roomDestroyed, this.sessionFinished);

      // when a remote stream is found
      Vvrtc.on(Vvrtc.EventsType.remoteStream, this.participantJoined);

      Vvrtc.on(Vvrtc.EventsType.remoteUnpublished, this.participantDisconnected);
      Vvrtc.on(Vvrtc.EventsType.remoteCleanup, this.participantDisconnected);

      // If there is a network issue, then the ice connection may be failed. Handle this here.
      Vvrtc.on(Vvrtc.EventsType.localIceState, state => {
        logger.info(`Ice State Changed: ${state}`);
        if (state === 'failed') {
          this.leaveRoomIfJoined();
          // Alert user
          this.$toast.warning('There was a problem with the internet connection. Please try reconnecting.', {
            toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
          });
          // Redirect to dashboard
          this.goToDashboard();
        }
      });
    },

    /**
     * Show a message to the user, log the error and then redirect back out of the call.
     * @param error
     * @param message
     */
    connectionError(error, message) {
      logger.error(
        'Unable to join room', error, { visitId: this.visitId }, 'VisitCall:joinRoom:2',
      );
      this.$swal({
        title: 'Unable to join call',
        text: message,
        icon: 'warning',
        button: 'Ok',
      }).then(() => {
        // Redirect to visit details
        this.goToWaitingRoom();
      });
    },
    /**
     * If a participant joins the room, passing through the remote feed and stream
     */
    participantJoined(data) {
      const identity = data.remoteFeed.identity.toLowerCase();
      logger.message(`>> Participant connected ${identity}`);

      if (identity.includes('visitor')) {
        // Removed this as Cameron has a state where he set the app to the background but hte stream didn't stop.
        this.visitorAppInForeground = true;
        this.visitorStream = data.stream;

        logger.message(`Adding new stream for Visitor. Call state is currently:${this.callState}`);

        // this.visitorConnected(data.remoteFeed); Just calls the below line then deals with tracks.
        this.waitingForVisitor = false;

        if (this.callState !== CALL_STATES.PAUSED_MT) {
          // If it's not paused..... and app is in foreground set to active. Better to show the video than be in a
          // trapped state?
          const previewContainer = document.getElementById('remote-video-feed');
          console.log('Adding Feed with Audio set to:', this.callState, this.callState !== CALL_STATES.ACTIVE);
          Vvrtc.attachMediaStream(previewContainer, data.stream, this.muteRemoteAudio);
          this.callState = CALL_STATES.ACTIVE;
          try {
            const videoTracks = data.stream.getVideoTracks();
            const remoteVideo = document.getElementById('remote-video-feed');
            if (videoTracks === null || videoTracks === undefined || videoTracks.length === 0) {
              console.log('>>> NO VIDEO FEED >>>');
              // No remote video
              remoteVideo.classList.add('hidden');
              this.visitorNoVideo = true;
            } else {
              console.log('>>> VIDEO FEED ENABLED >>>');
              remoteVideo.classList.remove('hidden');
              this.visitorNoVideo = false;
            }
          } catch (err) {
            console.log('There was an error looking at the video tracks on the stream:', err);
          }
        }
      } else if (identity.includes('masterterminal')) {
        const masterTerminalAudio = document.getElementById('mt-audio');
        Vvrtc.attachMediaStream(masterTerminalAudio, data.stream);
      }
    },
    /**
     * If the session Terminates or the rooms is destroyed exit out.
     */
    async sessionFinished() {
      // We're leaving
      this.setPrisonerLeftCall();

      if (this.leavingNaturally !== true) {
        // Show popup to say the room was terminated
        this.$toast.warning('The room has been terminated, you will be redirected back to the dashboard', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      }

      // Redirect to dashboard
      this.goToDashboard();
    },
    participantDisconnected(participant) {
      const identity = participant.identity.toLowerCase();
      console.log('Participant disconnected: ', identity);

      if (identity.includes('visitor')) {
        console.log('Removing remote video feed.', identity);
        const remoteVideoFeed = document.getElementById('remote-video-feed');
        Vvrtc.removeMediaStream(remoteVideoFeed);
        // Remove the no video mesasges
        this.visitorNoVideo = false;
      }
    },
    muteVisitorAudioAndHideVideo() {
      // Get the audio track in the dom
      const remoteVideoFeed = document.getElementById('remote-video-feed');
      Vvrtc.removeMediaStream(remoteVideoFeed);
      this.muteRemoteVideo = true;
      this.muteRemoteAudio = true;
    },
    // ##################################################
    // ############## Notification Methods ##############
    notifyFaceLeftFrame() {
      logger.message('<---FACE LEFT--->');
      // Create Dto
      const faceLeftEventDto = {
        visit_id: this.visitId,
        type: CALL_EVENT_TYPES.EVENT,
        sub_type: CALL_EVENT_EVENT_SUB_TYPES.FACE_LEFT,
      };
      // Send event to the API
      this.createGeneralEvent(faceLeftEventDto);
    },
    createGeneralEvent(generalEventDto) {
      axios({
        url: '/api/v1/call-events/create/general',
        method: 'POST',
        data: generalEventDto,
      }).catch(err => {
        logger.error('Cannot create general event', err, {
          dto: generalEventDto,
          visitId: this.visitId,
        }, 'VisitCall:createGeneralEvent');
      });
    },
    // ##################################################
    // ################### WS Methods ###################
    async handleWS() {
      const userToken = localStorage.getItem('userTokenCell');
      socket = io.connect(getWsEndpoint(), {
        query: {
          token: `Bearer ${userToken}`,
        },
        transports: ['websocket'],
      });

      socket.on('connect', () => {
        this.joinVisitorRoomWS();
      });

      socket.on('connect_error', err => {
        console.log('socket connect error', err);
        logger.warn('WS Connection error', err, {
          visitId: this.visitId,
          wsWasConnected: this.wsConnected,
        }, 'VisitCall:handleWS:connect_error');
        if (this.wsConnected) {
          // Start polling
          this.pollLatestCallAction();
          // Stop snapshotting
          clearInterval(this.snapshotIntervalId);
          // Set WS Connected to false
          this.wsConnected = false;
        }
      });

      // Handle reconnection
      socket.on('reconnect', () => {
        this.joinVisitorRoomWS();
      });

      // Handle call events from the server
      socket.on('callEventFromServer', this.handleCallEvent);

      // Handle rotate events
      socket.on('ptRotateFeedFromServer', rotationDegrees => {
        this.rotationDegrees = rotationDegrees;
        // Rotate video feed
        if (document.getElementById('prisoner-video')) {
          document.getElementById('prisoner-video').style.transform = `translateX(-50%) rotate(${rotationDegrees}deg)`;
        }
      });
    },
    joinVisitorRoomWS() {
      // Join as Visitor
      socket.emit('prisonerTerminalJoinRoom', this.visitId, err => {
        if (err) {
          logger.error('Error joining visitor WS Room', err, { visitId: this.visitId }, 'VisitCall:joinVisitorRoomWS');
          // Leave the room if joined
          this.leaveRoomIfJoined();
          // Alert user
          this.$toast.warning('Error connecting to server. Please check you are connected to the internet and try again.', {
            toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
          });
          // Redirect to dashboard
          this.goToDashboard();
        } else {
          this.wsConnected = true;
          // Stop polling
          clearInterval(this.latestCallStateIntervalId);
          logger.message('>> Connected to WS as PT');
          // Clear interval if there is one
          if (this.snapshotIntervalId) {
            clearInterval(this.snapshotIntervalId);
          }

          const prisonSnapshotEnabled = this.prison && this.prison.send_preview_images_from_pt;

          // Begin snapshots if on cs_version is -1 or prison requires snapshots from client
          if ((typeof (this.visit.cs_version) !== 'undefined' && this.visit.cs_version === -1) || prisonSnapshotEnabled) {
            this.snapshotCall();
          }
        }
      });
    },
    handleCallEvent(callEvent) {
      // console.log('event', callEvent);
      switch (callEvent.sub_type) {
        case CALL_EVENT_ACTION_SUB_TYPES.TERMINATED:
          // eslint-disable-next-line no-case-declarations
          let text = 'Your call has been terminated by site security.';

          if (this.visit.termination_reason) {
            text += `\nThe reasons for termination are:\n
            Please make sure to abide by all rules during your visit.`
          }

          // Warn user
          this.$swal({
            title: 'Call Terminated',
            text,
            icon: 'warning',
          });
          // Leave the call gracefully
          this.callTerminated();
          break;

        case CALL_EVENT_ACTION_SUB_TYPES.PAUSED_MT:
          // Warn user
          this.$toast.warning('The call has been paused. You are now speaking with a establishment officer', {
            toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
          });
          this.callPausedMT();
          break;

        case CALL_EVENT_ACTION_SUB_TYPES.RESUMED_MT:
          if (this.callState !== CALL_STATES.ACTIVE) {
            // Alert user
            this.$toast.success('The call has been resumed', {
              toastClassName: ['toast-std', 'success-toast'], timeout: 5000,
            });
            if (this.visitorAppInForeground) {
              // Set the call state to hide the overlay
              this.callState = CALL_STATES.ACTIVE;
              this.callStateLastUpdate = new Date();
              // Re-attach visitor video and audio in case we are polling
              this.resumeVisitorIfTrackPublishMissed();
            } else {
              // The call may have resumed, but the visitor is still minimised on the app
              this.callState = CALL_STATES.PAUSED_APP_IN_BACKGROUND;
              this.callStateLastUpdate = new Date();
            }
          }
          break;

        case CALL_EVENT_ACTION_SUB_TYPES.PAUSED_INVALID_FACE:
          this.callPausedInvalidFace();
          break;

        case CALL_EVENT_ACTION_SUB_TYPES.PAUSED_ADULT_CONTENT:
          this.callPausedAdultContent();
          break;

        case CALL_EVENT_ACTION_SUB_TYPES.RESUMED_ADULT_CONTENT:
        case CALL_EVENT_ACTION_SUB_TYPES.RESUMED_INVALID_FACE:
          if (this.visitorAppInForeground) {
            // Set the call state to hide the overlay
            this.callState = CALL_STATES.ACTIVE;
            this.callStateLastUpdate = new Date();
            // Re-attach visitor video and audio in case we are polling
            this.resumeVisitorIfTrackPublishMissed();
          } else {
            // The call may have resumed, but the visitor is still minimised on the app
            this.callState = CALL_STATES.PAUSED_APP_IN_BACKGROUND;
            this.callStateLastUpdate = new Date();
          }
          break;

        case CALL_EVENT_EVENT_SUB_TYPES.VISITOR_LEFT:
          // Show warning
          this.$swal({
            title: 'Call Ended',
            text: `Call Ended ${this.visit.visitor.firstname}. If you think this was an error you can rejoin the call.`,
            icon: 'info',
            button: 'Ok',
          });

          // Leave the call
          this.leaveRoomIfJoined();
          // Redirect to dashboard
          this.goToDashboard();
          break;

        case CALL_EVENT_EVENT_SUB_TYPES.APP_TO_BACKGROUND:
          this.visitorAppInForeground = false;
          this.callPausedAppToBackground();
          break;

        case CALL_EVENT_EVENT_SUB_TYPES.APP_TO_FOREGROUND:
          this.visitorAppInForeground = true;
          if (this.callState !== CALL_STATES.PAUSED_MT) {
            // Set the call state to hide the overlay
            this.callState = CALL_STATES.ACTIVE;
            this.callStateLastUpdate = new Date();
            // Re-attach visitor video and audio in case we are polling
            this.resumeVisitorIfTrackPublishMissed();
          }
          break;

        case CALL_EVENT_EVENT_SUB_TYPES.VISITOR_SCREEN_SHOT:
          // Increase screen shots taken
          this.screenShotsTaken += 1;
          if (this.screenShotsTaken < 2) {
            // Show warning text
            this.$swal({
              title: 'WARNING: Screen Shot Detected',
              text: 'Please be aware that if your caller takes another screen shot your call will be terminated.',
              icon: 'warning',
            });
          }
          break;
        // Soft Pause
        case CALL_EVENT_ACTION_SUB_TYPES.SOFT_PAUSE_ADULT_CONTENT:
          this.getPausedAdultContentText()
          this.muteVisitorAudioAndHideVideo();
          this.callState = CALL_STATES.PAUSED_ADULT_CONTENT;
          this.callStateLastUpdate = new Date();
          break;
        case CALL_EVENT_ACTION_SUB_TYPES.SOFT_PAUSE_INVALID_FACE:
          this.getPausedInvalidFacesText()
          this.muteVisitorAudioAndHideVideo();
          this.callState = CALL_STATES.PAUSED_INVALID_FACES;
          this.callStateLastUpdate = new Date();
          break;
        case CALL_EVENT_ACTION_SUB_TYPES.SOFT_PAUSE_TOO_MANY_FACES:
          this.getPausedInvalidFacesText()
          this.muteVisitorAudioAndHideVideo();
          this.callState = CALL_STATES.PAUSED_INVALID_FACES;
          this.callStateLastUpdate = new Date();
          break;
        case CALL_EVENT_ACTION_SUB_TYPES.SOFT_PAUSE_RESUMED: {
          // Remove the blur
          this.muteRemoteAudio = false;
          this.muteRemoteVideo = false;

          this.$toast.success('The call has been resumed', {
            toastClassName: ['toast-std', 'success-toast'], timeout: 5000,
          });
          if (this.visitorAppInForeground) {
            // Set the call state to hide the overlay
            this.callState = CALL_STATES.ACTIVE;
            this.callStateLastUpdate = new Date();
          } else {
            // The call may have resumed, but the visitor is still minimised on the app
            this.callState = CALL_STATES.PAUSED_APP_IN_BACKGROUND;
            this.callStateLastUpdate = new Date();
          }
          break;
        }

        case CALL_EVENT_ACTION_SUB_TYPES.VISITOR_MUTED:
          // Warn user
          this.$toast.warning('Your caller has muted their mic so you can not hear them.', {
            toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
          });
          this.setVisitorMuted(true);
          break;

        case CALL_EVENT_ACTION_SUB_TYPES.VISITOR_UNMUTED:
          // Warn user
          this.$toast.warning('Your caller has unmuted their mic so you can hear them.', {
            toastClassName: ['toast-std', 'success-toast'], timeout: 5000,
          });
          this.setVisitorMuted(false);
          break;
      }
    },
    setVisitorMuted(value) {
      this.visitorMuted = value;
    },
    setMuted(value) {
      this.muted = value;

      if (this.localStream) {
        const tracks = this.localStream.getAudioTracks();
        tracks[0].enabled = !value;
      }

      this.createPrisonerEvent({
        visit_id: this.visitId,
        type: 'Event',
        sub_type: value ? 'Prisoner_Muted' : 'Prisoner_Unmuted',
      });
    },
    async resumeVisitorIfTrackPublishMissed() {
      const remoteVideoFeed = document.getElementById('remote-video-feed');
      await Vvrtc.removeMediaStream(remoteVideoFeed);

      logger.message('Trying to attach client stream again. Current client stream: ', this.visitorStream);
      Vvrtc.attachMediaStream(remoteVideoFeed, this.visitorStream);

      this.muteRemoteVideo = false;
      this.muteRemoteAudio = false;
    },
    // ##################################################
    // ############### Call Text Methods ################
    getWaitingForText() {
      const contact = this.loadingVisit ? 'contact' : this.visit.visitor.firstname;
      return `Waiting for ${contact}`;
    },
    getVisitorNoVideoText() {
      const contact = this.loadingVisit ? 'contact' : this.visit.visitor.firstname;
      return `${contact} is having connection issues. Waiting for their connection to improve.`;
    },
    getPausedInvalidFacesText() {
      return `The Call has been paused due to invalid faces detected in stream....\n
                An invalid face could be someone that is unverified by establishment security or a partial face of an approved visitor.
                Things like coffee cups or light covering your contacts face could cause this to happen.`;
    },
    getPausedAdultContentText() {
      return `The Call has been paused due to adult content detected in stream...\n
                Please ensure no further adult content is shown.`;
    },
    getMtPausedText() {
      return 'An establishment officer has joined the call and paused the stream.';
    },
    getPausedAppInBackgroundText() {
      return 'The call has been paused due to losing focus on the app. The call will resume once they return to the app';
    },
    checkForScreenshots() {
      document.addEventListener('keyup', code => {
        if (code.key === 'PrintScreen') {
          this.createGeneralEvent({
            visit_id: this.visitId,
            type: CALL_EVENT_TYPES.EVENT,
            sub_type: CALL_EVENT_EVENT_SUB_TYPES.VISITOR_SCREEN_SHOT,
          });
        }
      });
    },
    callPausedAppToBackground() {
      if (this.callState !== CALL_STATES.PAUSED_APP_IN_BACKGROUND) {
        this.$toast.info(`Call paused due to ${this.visit.visitor.firstname} minimising the app`, {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
        // Remove visitor video and audio
        this.muteVisitorAudioAndHideVideo();
        // Send face left event
        this.notifyFaceLeftFrame();
        // Set the call state to show the overlay
        this.callState = CALL_STATES.PAUSED_APP_IN_BACKGROUND;
        this.callStateLastUpdate = new Date();
      }
    },
  },
};

</script>
